module.exports = __webpack_public_path__ + "static/media/about-us1.49fb6ad7.jpg";